import { createRouter, createWebHistory } from 'vue-router'
import { useStore } from '@/store/DefaultStore.js';
import ShowNotification from '@/services/ToastService';
import UserService from '@/services/UserService';

const allUsersRoles = ['CUSTOMER', 'GENERAL', 'ADMIN'];
const generalRoles = ['GENERAL', 'ADMIN'];
const adminRoles = ['ADMIN'];

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('../components/Views/Login/LoginView.vue'),
      meta: { isPublic: true }
    },
    {
      path: '/inicio',
      name: 'home',
      component: () => import('../components/Views/Home/HomeView.vue'),
      meta: { roles: generalRoles }
    },
    {
      path: '/expedientes',
      name:'files',
      component: () => import('../components/Views/Files/FilesView.vue'),
      meta: { roles: allUsersRoles }
    },
    {
      path: '/expediente/:PKFile/:PKTask?/:PKDocument?/:PKAgreement?',
      name: 'fileDetail',
      component: () => import('../components/Views/Files/FileDetail/FileDetail.vue'),
      meta: { roles: allUsersRoles },
      props: true
    },
    {
      path: '/calendario',
      name: 'calendar',
      component: () => import('../components/Views/Calendar/CalendarView.vue'),
      meta: { roles: allUsersRoles },
    },
    {
      path: '/acuerdos/:PKAgreement?',
      name: 'agreements',
      component: () => import('../components/Views/Agreements/AgreementsView.vue'),
      meta: { roles: allUsersRoles },
      props: true
    },
    {
      path: '/usuarios',
      name: 'users',
      component: () => import('../components/Views/Users/UsersView.vue'),
      meta: { roles: adminRoles },
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('../components/Views/Login/RegisterView.vue'),
      meta: { isPublic: true }
    },
    {
      path: '/organizaciones',
      name: 'organizations',
      component: () => import('../components/Views/Organizations/OrganizationsView.vue'),
      meta: { isSuperadminsOnly:  true }
    },
    {
      path: '/lecturaAutomaticaDeAcuerdos',
      name: 'agreementsReadingProcessLog',
      component: () => import('../components/Views/Agreements/AgreementsReadingProcessLog/AgreementsReadingProcessLogView.vue'),
      meta: { roles: generalRoles },
    },
    {
      path: '/aprobacionDeAcuerdos',
      name: 'agreementsApprovals',
      component: () => import('../components/Views/Agreements/AgreementsApprovals/AgreementsApprovalsView.vue'),
      meta: { roles: generalRoles },
    },
    {
      path: '/configuracion/:SettingName?',
      name: 'settings',
      component: () => import('../components/Views/Settings/SettingsView.vue'),
      meta: { roles: allUsersRoles },
      props: true
    },
    {
      path: '/notificacionDeAcuerdos',
      name: 'agreementsNotifications',
      component: () => import('../components/Views/Agreements/AgreementsNotification/AgreementsNotificationView.vue'),
      meta: { roles: generalRoles },
    },
    {
      path: '/privacy-policy',
      name: 'privacyPolicy',
      component: () => import('../components/Views/Legal/PrivacyPolicyView.vue'),
      meta: { isPublic: true }
    },
    {
      path: '/terms-of-service',
      name: 'termsOfService',
      component: () => import('../components/Views/Legal/TermsOfServiceView.vue'),
      meta: { isPublic: true }
    },
    {
      path: "/:catchAll(.*)",
      name:'notFound',
      component: () => import('../components/Views/Home/HomeView.vue')
    },
  ]
})

router.beforeEach(async (to, from, next) => {
  let showError = true;
  let goToPage = 'login';
  const store = useStore();

  try
  {
    store.currentPanel = to.name;

    // If its a not found page, redirects to the login
    if(to.name == 'notFound'){
      next({name: 'login'});
      return;
    }

    // If its a public page, avoids role validations
    if(to.meta.isPublic){
      next();
      return;
    }

    // If the user data is not loaded, does it
    if(store.LoggedUser == null){
      await UserService.SetUserInitialData();
    }

    // If the user is customer and tries to go to home redirects it to agreements
    if(to.name == 'home' && store.LoggedUser.Role == 'CUSTOMER'){
      router.push({name: 'files'});
      next();
      return;
    }

    // If page is for superadmins only and user is not
    if(to.meta.isSuperadminOnly && !store.LoggedUser.IsSuperadmin){
      goToPage = from.name || 'login';
      throw new Error('NO TIENES PERMISO PARA ACCEDER A ESTA PANTALLA');
    }

    // If user does not have access for page because of role
    if(to.meta.roles && !to.meta.roles?.includes(store.LoggedUser.Role)){
      goToPage = from.name || 'home';
      throw new Error('NO TIENES PERMISO PARA ACCEDER A ESTA PANTALLA');
    }

    next();
  }
  catch(error){
    if(showError){
      ShowNotification.Error(error.message);
    }

    next({name: goToPage});
    throw error;
  }
});

export default router